import React from 'react';
import DropdownWithIcon from './DropdownWithIcon';
import roleIcon from '../assets/users/role.svg';

const RoleChooser = ({
  value,
  onChange,
  error,
  helperText,
  required
}) => {
  return (
    <DropdownWithIcon
      icon={roleIcon}
      placeholder="הרשאה"
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      required={required}
    >
      <option value="USER">צפייה</option>
      <option value="EDITOR">עריכה</option>
      <option value="ADMIN">אדמין</option>
    </DropdownWithIcon>
  );
};

export default RoleChooser;
